import useFetchData from '../../../../../hooks/fetchHook';

export const useGetUnreadCount = () => {
  const [{ data = [], isLoading, isError, error }, _, refetchUnreadCount] =
    // avoid fetching unread count on initial load
    useFetchData('office_support_tickets/unread_count', { ignore: true });

  return { data, isLoading, isError, error, refetchUnreadCount };
};
